import React from 'react';
import './DisputeAlreadyRaisedDrawer.css';

function DisputeAlreadyRaisedDrawer({ onClose }) {
  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="drawer-content" onClick={(e) => e.stopPropagation()}>
        <h3>Already Disputed</h3>
        <p>
          This order has already been submitted to the support team.
          Please wait for our team to review and respond.
        </p>
        <button className="drawer-black-btn" onClick={onClose}>Okay</button>
      </div>
    </div>
  );
}

export default DisputeAlreadyRaisedDrawer;
